import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageBuilderItem } from '../page-builder-components.models';

@Component({
    selector: 'app-page-builder-result-dialog',
    templateUrl: './page-builder-result-dialog.component.html',
    styleUrls: ['./page-builder-result-dialog.component.scss']
})
export class PageBuilderResultDialogComponent implements OnInit {
    config: PageBuilderItem[]; 
    datas: any;

    constructor(
        public dialogRef: MatDialogRef<PageBuilderResultDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { config: PageBuilderItem[], datas: any },
    ) {
        this.config = data.config;
        this.datas = data.datas;
    }

    ngOnInit() {
    }
}